import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import NamedValuesService from '../../services/NamedValues.service'
import { DEFAULT_STALE_TIME } from '../../utils/reactQuery'

export const useNamedValues = (page: number, size: number, name?: string, value?: string) => {
  const { org } = useParams()
  return useQuery<any>({
    queryKey: ['named-values', org, name, value, page, size],
    queryFn: () => NamedValuesService.listNamedValues(org!, page, size, name, value),
    placeholderData: keepPreviousData,
    enabled: !!org,
    staleTime: DEFAULT_STALE_TIME,
  })
}
